export default "assets/images/email.png";